

import Vue from "vue";

import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Component
export default class ChipsRate extends Vue {

  @Prop() data: any

  @Prop() type !: string

  @Prop() on !: any;

  @Prop() attrs !: any;

  @Prop() statPeriod !: string;

  chipsColor = '#edf6f3'

  textColor = ''

  iconType = 'same'

  relativeValue: number | string = 0;

  absoluteValue: number | string = 0;

  textContent = ' 0 % (0)'

  @Watch('data')
  mountedUpdate() {

    this.chipsCalculator()
    this.chipsColor = (typeof this.relativeValue === "number" && this.relativeValue > 0)
      ? '#edf6f3' : '#ED69511A'

    this.textColor = this.textColorSelection()

    this.iconType = this.IconSelection()
    this.textContentAdd()

  }


  mounted() {

    if (this.data) {
      this.chipsCalculator()

    }
    this.chipsColor = (typeof this.relativeValue === "number" && this.relativeValue > 0)
      ? '#edf6f3' : '#ED69511A'

    this.textColor = this.textColorSelection()
    this.textContentAdd()

    this.iconType = this.IconSelection()
  }


  chipsCalculator() {

    const totalBookingP1 = this.type === "total" ? this.data.at(0).totalBooking : this.data.at(0).validBooking
    const totalBookingP2 = this.type === "total" ? this.data.at(1).totalBooking : this.data.at(1).validBooking

    this.relativeValue = totalBookingP2
      ? Math.floor(((totalBookingP1 - totalBookingP2) / totalBookingP2) * 100)
      : ''
    this.absoluteValue = (totalBookingP1 - totalBookingP2)

    if (this.type === "noShow") {

      const noShowBookingP1 = totalBookingP1 - this.data.at(0).completedBooking
      const noShowBookingP2 = totalBookingP2 - this.data.at(1).completedBooking

      this.relativeValue = noShowBookingP2
        ? Math.floor(((noShowBookingP1 - noShowBookingP2) / noShowBookingP2) * 100)
        : ''

      this.absoluteValue = (noShowBookingP1 - noShowBookingP2)

    }
  }

  chipsColorSelection() {
    if (typeof this.relativeValue === "number" && this.relativeValue > 0) {
      return '#edf6f3'
    }
    if (this.relativeValue === 0) {
      return ''
    }
    return '#ED69511A'
  }

  textColorSelection() {
    if (this.absoluteValue === 0) {
      return 'black'
    }
    if ((typeof this.relativeValue === "number" && this.relativeValue > 0) || (this.relativeValue === '' && this.absoluteValue !== 0)) {
      return '#4EA98B'
    }

    return '#ED6951'
  }

  IconSelection() {
    if (this.relativeValue === 0
      || (this.relativeValue === '' && this.absoluteValue === 0)
    ) {
      return 'same'
    }
    if ((typeof this.relativeValue === "number" && this.relativeValue > 0) || this.relativeValue === '') {
      return 'up'
    }
    return 'down'
  }

  textContentAdd() {
    const relativeSign = (typeof this.relativeValue === "number" && this.relativeValue > 0)
      ? '+'
      : ''
    const absoluteSign = (typeof this.absoluteValue === "number" && this.absoluteValue > 0) ? '+' : ''

    const fragmentSpace = `${absoluteSign} ${this.absoluteValue}`.trim()

    this.textContent = this.relativeValue ? `${relativeSign} ${this.relativeValue} % (${fragmentSpace})` : `${fragmentSpace}`
  }

  showStatComparison(periodStat: string) {
    switch (periodStat) {
      case "Aujourd'hui":
        return "/ hier"
      case 'Hier':
        return '/ avant-hier'
      case 'Cette semaine':
        return "/ semaine dernière"
      case 'Ce mois':
        return '/ mois dernier'
      case 'Cette année':
        return "/ année dernière"
      default:
        return '/ période précédente'
    }
  }
}
